import { Button } from "components/ButtonNew";
import { DynamicRecordDrawer } from "features/shared/components/dynamic-form";
import { CatalogTablePanel } from "features/shared/components/technical-config-tab/CatalogTablePanel";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { useGetRoomTypeCatalog } from "../api/hooks";
import { getRoomCatalogTableHeaders } from "../lib/roomCatalogTableHeaders";
import { RoomCatalogAddModal } from "./RoomCatalogAddModal";

type RoomCatalogDrawerProps = {
  onClose: () => void;
  open: boolean;
};

export const RoomCatalogDrawer = ({ onClose, open }: RoomCatalogDrawerProps) => {
  const { t } = useTranslation();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const { data: catalog = [], isLoading } = useGetRoomTypeCatalog(open);
  const headers = useMemo(() => getRoomCatalogTableHeaders(t), [t]);

  return (
    <>
      <DynamicRecordDrawer
        headerActions={
          <Button onClick={() => setIsAddModalOpen(true)} size="md" variant="secondary">
            {t("TechnicalData.room.addCatalogItem")}
          </Button>
        }
        hideFooter
        isLoading={isLoading}
        onClose={onClose}
        open={open}
        title={t("TechnicalData.room.catalogTitle")}
        widthClassName="w-[90rem]"
      >
        <CatalogTablePanel data={catalog} headers={headers} idColumnName="id" isLoading={isLoading} />
      </DynamicRecordDrawer>
      <RoomCatalogAddModal catalog={catalog} onClose={() => setIsAddModalOpen(false)} open={isAddModalOpen} />
    </>
  );
};
